// Gallery slider
// -----------------------------------
(function ($) {
    $(function () {
        const $status = $('.slide-numbers'),
            $slickElement = $('.gallery-slider');

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            const i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });
        $slickElement.slick({
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0px', // added custom padding-right
            autoplay: false,
            speed: 1000,
            autoplaySpeed: 5000,
            infinite: false
        });
    });
})(jQuery);
